/**
 * Copies text that is still being fetched.
 *
 * Browsers only let a page write to the clipboard right after a click, and
 * Safari is strict about it: waiting for a request first loses that
 * permission. Handing over a promise for the text (ClipboardItem) keeps it.
 * Older browsers fall back to writeText, which is fine in Chrome/Firefox.
 *
 * Rejects if the text promise rejects or the browser refuses to copy.
 *
 * @param {Promise<string>} textPromise
 */
export const copyPromisedText = async (textPromise) => {
    if (navigator.clipboard?.write && typeof ClipboardItem !== "undefined") {
        const item = new ClipboardItem({
            "text/plain": textPromise.then((text) => new Blob([text], {type: "text/plain"})),
        });
        await navigator.clipboard.write([item]);
        return;
    }
    if (!navigator.clipboard?.writeText) {
        throw new Error("Clipboard not available");
    }
    await navigator.clipboard.writeText(await textPromise);
};
